module.exports = __webpack_public_path__ + "img/olsera_logo.1e1b8152.svg";